import { createAction } from '@reduxjs/toolkit';
import type {
    IAiGenerateImageRequest,
    IGenerateImageEnd,
    IResetGenerationImage,
    ISaveGeneratedImage,
    ISetGenerationPhotoScreenState,
} from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.types';

export const generateImageStart = createAction<IAiGenerateImageRequest>('aiPhotoGeneration/generateImageStart');

export const generateImageAnimationStart = createAction<IGenerateImageEnd>('aiPhotoGeneration/generateImageAnimationStart');

export const generateImageAnimationEnd = createAction('aiPhotoGeneration/generateImageAnimationEnd');

export const resetImageGeneration = createAction<IResetGenerationImage>('aiPhotoGeneration/resetImageGeneration');

export const incrementImageGenerationPercentage = createAction('aiPhotoGeneration/incrementImageGenerationPercentage');

export const changeImageGenerationLoaderText = createAction('aiPhotoGeneration/changeImageGenerationLoaderText');

export const cancelImageGeneration = createAction('aiPhotoGeneration/cancel');

export const saveGeneratedImage = createAction<ISaveGeneratedImage>('aiPhotoGeneration/saveGeneratedImage');

export const incrementAiGenerationsCount = createAction('aiPhotoGeneration/incrementAiGenerationsCount');

export const generationScreenOpened = createAction('aiPhotoGeneration/generationScreenOpened');

export const tryToShowMailSpacePromoModal = createAction('aiPhotoGeneration/handleTryToShowMailSpacePromoModal');

export const setGenerationPhotoScreenState = createAction<ISetGenerationPhotoScreenState>(
    'aiPhotoGeneration/setGenerationPhotoScreenState'
);

export const setAiPhotoGenerationSaved = createAction('aiPhotoGeneration/setAiPhotoGenerationSaved');
export const setAiPhotoGenerationRated = createAction('aiPhotoGeneration/setAiPhotoGenerationRated');
export const setAiPhotoGenerationCommented = createAction('aiPhotoGeneration/setAiPhotoGenerationCommented');
